export function isOnline(): boolean {
  return navigator.onLine;
}
